import { useEffect } from 'react'
import { useAuthStore } from '@/common/zustand/store/auth.store'
import { useDdjjMedicoStore } from '@/common/zustand/store/ddjj-medico.store'

// PBI 81906: banner y chip «DDJJ pendiente» leen este flag; el store comparte un solo
// request por contrato entre ambos. La regla (médico y DDJJ no subida) la calcula clientes_service.
export const useDdjjPendiente = () => {
  const contrato = useAuthStore((state) => state.contrato)
  const cargar = useDdjjMedicoStore((state) => state.cargar)
  const ddjjPendiente = useDdjjMedicoStore((state) => state.ddjjPendiente)

  useEffect(() => {
    cargar(contrato)
  }, [contrato, cargar])

  return ddjjPendiente
}
